import CnamLookup from "./CnamLookup";

export default CnamLookup;
